import { PagedResponseDto } from "../dtos/paged-response.dto";

const DEFAULT_FETCH_ALL_PAGE_SIZE = 10000;

type FetchPagedResponse<TDto> = (
  pageNumber: number,
  pageSize: number
) => Promise<PagedResponseDto<TDto>>;

function getTotalPages<TDto>(response: PagedResponseDto<TDto>, pageSize: number): number {
  return response.meta.totalPages ?? Math.ceil(response.meta.totalCount / pageSize);
}

export async function fetchAllPages<TDto>(
  fetchPage: FetchPagedResponse<TDto>,
  pageSize: number = DEFAULT_FETCH_ALL_PAGE_SIZE
): Promise<TDto[]> {
  const firstPage = await fetchPage(1, pageSize);
  const data = [...firstPage.data];
  const totalPages = getTotalPages(firstPage, pageSize);

  for (let pageNumber = 2; pageNumber <= totalPages; pageNumber += 1) {
    const page = await fetchPage(pageNumber, pageSize);
    data.push(...page.data);
  }

  return data;
}
